import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Stay Connected with the Best Internet and Cable Services"} subTitle={"Discover Our Offers"} linear sideHeading />
        <Button link={"Pricing"} title={"Explore Packages"} />

      </div>
    </section>
  );

};

export default Banner;